import React from "react";
import companyLogo from "../../../assests/ktlogo.svg";
import styles from "./authLayout.module.scss";
import { brandConfig } from "../../../auth/config";

/**
 * The card shell shared by every unauthenticated screen: landing chooser, password login,
 * OTP login, forgot password, set password and sign-up.
 *
 * Only the page shell lives here - card, logo, heading, footer. The form controls
 * inside it are plain elements styled by the same stylesheet, re-exported below as `authStyles`
 * so a page can reach the shared `.fieldGroup` / `.primaryButton` / `.optionCard` classes without
 * either duplicating them or importing another component's stylesheet by path.
 *
 * `pages/Login/Login.jsx` (the SSO page, reachable from the landing page's "sso" card)
 * deliberately does NOT use this: it keeps its own light card.
 */
export const authStyles = styles;

export default function AuthLayout({ heading, subheading, children, wide = false, footer }) {
  return (
    <div className={styles.container}>
      <div className={`${styles.glassCard} ${wide ? styles.glassCardWide : ""}`}>
        <div className={styles.header}>
          <img src={companyLogo} alt={brandConfig.appName} className={styles.companyLogo} />
          {heading && <h1 className={styles.heading}>{heading}</h1>}
          {subheading && <p className={styles.subheading}>{subheading}</p>}
        </div>

        {children}

        {footer}

        <a
          href="https://www.kriha.in"
          target="_blank"
          rel="noreferrer"
          className={styles.createdBy}
        >
          Designed by <span>Kriha<sup>&#8482;</sup></span>
        </a>
      </div>
    </div>
  );
}
